import { Mail } from 'lucide-react';
import type { ReactElement } from 'react';

interface VerificationSentScreenProps {
  verificationEmail: string;
  resendSuccess: boolean;
  resendLoading: boolean;
  onResend: () => void;
  onBackToSignIn: () => void;
}

export function VerificationSentScreen({
  verificationEmail,
  resendSuccess,
  resendLoading,
  onResend,
  onBackToSignIn,
}: VerificationSentScreenProps): ReactElement {
  return (
    <div className="min-h-dvh bg-theme-bg flex flex-col">
      <header className="p-6">
        <h1 className="text-2xl font-bold text-white">Parlay Picker</h1>
        <p className="text-theme-text-secondary">AI-powered basketball prop analysis</p>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 pb-12">
        <div className="w-full max-w-md">
          <div className="bg-theme-surface rounded-lg p-6 border border-theme-border text-center">
            <div className="w-16 h-16 bg-theme-primary-fill rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-8 h-8 text-theme-on-primary-fill" />
            </div>
            <h2 className="text-xl font-bold text-white mb-2">Verify Your Email</h2>
            <p className="text-theme-text-secondary mb-4">
              We sent a verification link to{' '}
              <span className="text-white font-medium">{verificationEmail}</span>. Check your inbox
              and click the link to activate your account.
            </p>

            {resendSuccess && (
              <p className="text-theme-success text-sm mb-4">Verification email sent!</p>
            )}

            <button
              type="button"
              onClick={onResend}
              disabled={resendLoading}
              className="w-full bg-theme-surface-hover hover:bg-theme-border text-white font-medium py-2.5 px-4 rounded-lg transition-colors mb-3 disabled:opacity-50"
            >
              {resendLoading ? 'Sending...' : 'Resend Verification Email'}
            </button>

            <button
              type="button"
              onClick={onBackToSignIn}
              className="text-theme-primary hover:text-theme-primary-hover text-sm"
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
